import { useEffect } from 'react';

import { getAccountTypeForConnection, productId } from '@trader/constants';
import { useMst } from '@trader/store';

import { EConnectionHub, EConnectionHubSubscriber } from './core/types';
import { useHub } from './core/useHub';

interface IMessage {
  marginFree: number;
  freeMargin: number;
  balance: number;
  equity: number;
  marginLevel: number;
  profit: number;
  credit: number;
  brand: number;
  login: string;
  pl: number;
}

export const usePortfolioLocal = (
  platformLogin: string,
  accType: string,
  onUpdate: (message: IMessage) => void
) => {
  const store = useMst();

  const idToken = store.auth.tokens.idToken || '';
  const product = store.user.getAccountProduct();

  const handleUpdate = (message: IMessage) => {
    onUpdate({
      ...message,
      freeMargin: message.marginFree,
      pl: message.profit,
    });
  };

  const { unsubscribe, subscribe } = useHub<IMessage>({
    url: '/v2/account',
    hub: EConnectionHub.LocalPortfolio,
    subscriber: EConnectionHubSubscriber.Portfolio,
    onMessage: handleUpdate,
    invokedName: 'portfolio',
  });

  useEffect(() => {
    subscribe(async connection => {
      await connection?.send(
        'SubscribeOnPortfolio',
        platformLogin,
        productId[product],
        getAccountTypeForConnection[accType]
      );
    });
    return () => {
      unsubscribe(async connection => {
        await connection?.send(
          'UnsubscribeFromPortfolio',
          platformLogin,
          productId[product],
          getAccountTypeForConnection[accType]
        );
      });
    };
  }, [platformLogin, idToken, product]);
};
